import React from "react";
import { Row, Col } from "react-bootstrap";
import { Section, Timeline } from "../components";
import history from "../data/history.json";
import { Mortarboard } from "react-bootstrap-icons";

const education = history.education;

export class Education extends React.Component {
  render() {
    return (
      <Section id="education" title="Education">
        <Row>
          <Col md={12}>
            <div className="timeline edu bg-white rounded shadow-dark padding-30 overflow-hidden">
              {education.map((e) => (
                <Timeline
                  key={e.degree}
                  time={e.period}
                  titleLink={e.link}
                  title={e.school}
                  icon={<Mortarboard />}
                >
                  <p>{e.degree}</p>
                </Timeline>
              ))}

              <span className="line" />
            </div>
          </Col>
        </Row>
      </Section>
    );
  }
}

export default Education;
